import { render, staticRenderFns } from "./imprimirproductos.vue?vue&type=template&id=73e708d5"
import script from "./imprimirproductos.vue?vue&type=script&lang=js"
export * from "./imprimirproductos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports